export let isMaterialsEqual = (a, b) => (
    a && b && (
    a.Material == b.Material &&
    a.Mgroup == b.Mgroup &&
    a.SubGroup == b.SubGroup &&
    a.Thickness == b.Thickness))


export let findMaterial = (Materials, material) => {
    return Materials && Materials.find((v) => isMaterialsEqual(v, material));
}
